
<template>
    <div>
        <v-file-input :key="fileInputKey" :label="label" v-model="fileList" small-chips :accept="accept" @change="beforeRead"
            :placeholder="placeholder" show-size counter :multiple="multiple" />
        <v-progress-linear :active="isuploading" :indeterminate="isuploading" absolute bottom
            color="deep-purple accent-4"></v-progress-linear>
    </div>
</template>

<script>
import userDocApi from "@/assets/js/userDocApi";
export default {
    name: "zyUpload",
    props: {
        path: {
            type: String,
            required: true,
            default: ""
        },
        label: {
            type: String,
            default: "文件上传"
        },
        accept: {
            type: String,
            default: "*"
        },
        multiple: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: "请选择文件"

        }
    },
    components: {},
    data() {
        return {
            isuploading: false,
            fileList: [],
            uploadInfo: [],
            fileInputKey:$func.getUUID_resource()
        }
    },
    methods: {
        beforeRead(file) {
            if(file==null){
                
                return;
            }
            
            // 验证
            let res = true;

            if (res) {
                this.afterRead(this.fileList);
            }
        },
        afterRead(file) {
            this.isuploading = true
            let _param = {}
            _param.content = file;
            _param.name = file.name;
            _param.label = file.name

            userDocApi.createFile(this.path, _param.name, _param, _r => {
                this.isuploading = false;
                if (_r.code == 200) {

                    // this.uploadfid=_r.data.fid;
                    let _rsl = {
                        path: `${this.path}/${_param.name}`,
                        label:file.name,
                        fileName: _param.name,
                        fileSize: file.size,
                        fid: _r.data.fid
                    };
                  
                    this.uploadInfo.push(_rsl)
                    this.$emit("finishUpload", this.uploadInfo)

                }
                else if(_r.code==409){
                    // 资源已存在
                }
                else {
                    this.$notify({ type: 'danger', message: '上传文件失败' })
                }
            })
        },

        init() {
            this.isuploading = false;
            this.fileInputKey=$func.getUUID_resource();
            this.fileList = [];
            this.uploadInfo = [];
        }

    },
    mounted() {

    }

}
</script>

<style lang="less" scoped>

/deep/.deep-purple.accent-4 {
    background-color: #6200ea!important;
    border-color: #6200ea!important;
}
</style>